import React, { ReactElement, useState } from 'react'
import { checkTransferSchema } from './checkTransferValidations'
import { Formik } from 'formik'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { RootState } from '../../store'
import { DistributionReasonInfo, RetirementConstraintsResponse, SearchAccountsResponsePayload } from '@Types'
import { DefaultFormValue } from './Types'
import { CountryItem } from '../../reducers/types'
import { getCountryList } from '../../actions'
import CheckForm from './CheckForm'

export interface Props {
  fromAccount: string
  iraConstraintData: RetirementConstraintsResponse
  account: SearchAccountsResponsePayload
  amountAvailable: number
  getCountryList: () => void
  countryList: CountryItem[]
  countryListLoading: boolean
  countryListFailedMessage?: string
  countryAutoSelectDataSet: { value: string }[]
  hasOvernightToApexPerm: boolean
  hasSubmitPermission: boolean
}

function CheckFormikWrapper({
  fromAccount,
  iraConstraintData,
  account,
  amountAvailable,
  getCountryList,
  countryList,
  countryListLoading,
  countryListFailedMessage,
  countryAutoSelectDataSet,
  hasOvernightToApexPerm,
  hasSubmitPermission
}: Props): ReactElement {
  const [selectedReason, setSelectedReason] = useState<DistributionReasonInfo | null>()

  const defaultValues: DefaultFormValue = {
    fromAccount,
    amountAvailable,
    accountNumber: account.accountNumber,
    isIra: iraConstraintData?.retirementAccount
  }

  const formikConfig = {
    initialValues: checkTransferSchema(countryList, defaultValues, iraConstraintData, selectedReason).cast({}),
    onSubmit: () => {},
    validationSchema: () => checkTransferSchema(countryList, defaultValues, iraConstraintData, selectedReason),
    validateOnMount: true,
    validateOnChange: true,
    validateOnBlur: true
  }

  const handleSelectReason = (reason: DistributionReasonInfo | null) => {
    setSelectedReason(reason)
  }

  return (
    <Formik {...formikConfig}>
      <CheckForm
        fromAccount={fromAccount}
        iraConstraintData={iraConstraintData}
        account={account}
        amountAvailable={amountAvailable}
        getCountryList={getCountryList}
        countryList={countryList}
        countryListLoading={countryListLoading}
        countryListFailedMessage={countryListFailedMessage}
        countryAutoSelectDataSet={countryAutoSelectDataSet}
        hasOvernightToApexPerm={hasOvernightToApexPerm}
        hasSubmitPermission={hasSubmitPermission}
        handleSelectReason={handleSelectReason}
        selectedReason={selectedReason}
      />
    </Formik>
  )
}

const mapStateToProps = (state: RootState) => {
  const {
    countryReducer: { countryListLoading, countryList, countryListFailedMessage }
  } = state

  const countryAutoSelectDataSet = countryList
    .filter((country) => country.isoName)
    .map((country) => ({ value: country.isoName! }))

  return { countryListLoading, countryList, countryListFailedMessage, countryAutoSelectDataSet }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    getCountryList: () => getCountryList(dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CheckFormikWrapper)
